import React, { useState, useRef } from 'react';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import Footer from '../footer';

const data = {
    classes: ['10-A', '10-B', '11-A'],
    batches: {
        '10-A': ['Batch 1', 'Batch 2'],
        '10-B': ['Batch 1'],
        '11-A': ['Batch Alpha', 'Batch Beta'],
    },
    students: {
        '10-A|Batch 1': ['Aman', 'Priya', 'Rahul'],
        '10-A|Batch 2': ['Ravi', 'Sneha'],
        '10-B|Batch 1': ['Vijay', 'Meera'],
        '11-A|Batch Alpha': ['Arjun', 'Neha'],
        '11-A|Batch Beta': ['Rohan', 'Simran'],
    },
    tests: ['Unit Test 1', 'Unit Test 2', 'Final Exam'],
};

export default function CertificateReportcard() {
    const [classSel, setClassSel] = useState('');
    const [batchSel, setBatchSel] = useState('');
    const [testSel, setTestSel] = useState('');
    const [studentOpts, setStudentOpts] = useState([]);
    const [studentSel, setStudentSel] = useState([]);
    const [showCards, setShowCards] = useState(false);
    const cardRef = useRef();

    const handleClass = (e) => {
        const cls = e.target.value;
        setClassSel(cls);
        setBatchSel('');
        setStudentSel([]);
        setShowCards(false);
        setStudentOpts([]);
    };

    const handleBatch = (e) => {
        const bat = e.target.value;
        setBatchSel(bat);
        setStudentSel([]);
        setShowCards(false);
        if (classSel && bat) {
            const key = `${classSel}|${bat}`;
            setStudentOpts(data.students[key] || []);
        } else {
            setStudentOpts([]);
        }
    };

    const handleSubmit = () => {
        if (classSel && batchSel && testSel && studentSel.length) {
            setShowCards(true);
            setTimeout(() => {
                cardRef.current?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        } else alert('Please select all fields!');
    };

    const handlePrint = () => window.print();

    return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid py-4">
                                <div className="card shadow-sm border-0 p-4">
                                    <h3 className="text-primary fw-bold mb-4">Report Card Generator</h3>
                                    <div className="row g-4">
                                        <div className="col-md-3">
                                            <label className="form-label fw-semibold">Class</label>
                                            <select className="form-select" value={classSel} onChange={handleClass}>
                                                <option value="">Select Class</option>
                                                {data.classes.map(c => <option key={c} value={c}>{c}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label fw-semibold">Batch</label>
                                            <select className="form-select" value={batchSel} onChange={handleBatch} disabled={!classSel}>
                                                <option value="">Select Batch</option>
                                                {(data.batches[classSel] || []).map(b => <option key={b} value={b}>{b}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label fw-semibold">Test</label>
                                            <select className="form-select" value={testSel} onChange={e => setTestSel(e.target.value)}>
                                                <option value="">Select Test</option>
                                                {data.tests.map(t => <option key={t} value={t}>{t}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label fw-semibold">Students</label>
                                            <select
                                                className="form-select"
                                                multiple
                                                value={studentSel}
                                                onChange={e => {
                                                    const opts = Array.from(e.target.selectedOptions, o => o.value);
                                                    setStudentSel(opts);
                                                }}
                                                disabled={!batchSel}
                                                style={{ height: '100px' }}
                                            >
                                                <option value="All">All Students</option>
                                                {studentOpts.map(s => <option key={s} value={s}>{s}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="text-end mt-4">
                                        <button className="btn btn-success px-4" onClick={handleSubmit}>Generate</button>
                                    </div>
                                </div>

                                {showCards && (
                                    <div ref={cardRef} className="mt-5">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h5 className="text-secondary">Generated Report Cards</h5>
                                            <button className="btn btn-outline-primary" onClick={handlePrint}>Print All</button>
                                        </div>
                                        <div className="row g-4">
                                            {(studentSel.includes('All') ? studentOpts : studentSel).map((name, idx) => (
                                                <div className="col-md-4" key={idx}>
                                                    <div className="card border border-primary shadow-sm">
                                                        <div className="card-body text-center">
                                                            <h5 className="text-primary fw-bold">{name}</h5>
                                                            <p>Class: {classSel}</p>
                                                            <p>Batch: {batchSel}</p>
                                                            <p>Test: {testSel}</p>
                                                            <hr />
                                                            <p className="text-muted small">Generated on: {new Date().toLocaleDateString()}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <Footer />
                            <div className="content-backdrop fade"></div>
                        </div>
                    </div>
                    <div className="layout-overlay layout-menu-toggle"></div>
                    <div className="drag-target"></div>
                </div>
            </div>
        </>
    );
}
